module.exports = "images/soundOnFocus.3b0dd035.png";